import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SERIF, UI, MONO } from '../../design/theme';
import { shareChallenge } from '../share';
import { challengeStatLabel } from '../challengeUtils';

export default function CommunityChallengeCard({ theme, challenge, loading, onJoin }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div data-testid="v2-challenge-card-loading" style={{ padding: '0 16px', marginTop: 22 }}>
        <div style={{ height: 210, borderRadius: 28, background: theme.skeleton, opacity: 0.72 }}/>
      </div>
    );
  }
  if (!challenge) return null;

  const stats = challenge.stats || {};
  const sightings = Number(stats.sightings || 0);
  const participants = Number(stats.participants || 0);

  return (
    <div data-testid="v2-challenge-card" style={{ padding: '0 16px', marginTop: 22 }}>
      <div style={{
        position: 'relative', overflow: 'hidden', borderRadius: 30,
        background: `linear-gradient(135deg, ${challenge.color || theme.primary}, #FFB347 58%, #FFE7A6)`,
        color: '#fff', boxShadow: '0 18px 40px rgba(255, 122, 61, 0.24)',
        border: '1px solid rgba(255,255,255,0.45)',
      }}>
        <div style={{ position: 'absolute', right: -24, top: -24, width: 148, height: 148, borderRadius: '50%', background: 'rgba(255,255,255,0.18)' }}/>
        <div style={{ position: 'absolute', right: 18, top: 28, fontSize: 58, filter: 'drop-shadow(0 8px 12px rgba(0,0,0,0.16))' }}>🐈</div>
        <div style={{ padding: 20, position: 'relative', zIndex: 1 }}>
          <div style={{ fontFamily: MONO, fontSize: 10, fontWeight: 900, letterSpacing: 1, opacity: 0.9, textTransform: 'uppercase' }}>
            {challenge.eyebrow || 'ภารกิจชุมชน'}
          </div>
          <div style={{ fontFamily: SERIF, fontSize: 30, lineHeight: 1, fontWeight: 900, marginTop: 8, maxWidth: 250 }}>
            {challenge.title}
          </div>
          <div style={{ fontFamily: UI, fontSize: 13, lineHeight: 1.45, opacity: 0.92, marginTop: 10, maxWidth: 390 }}>
            {challenge.subtitle}
          </div>

          <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
            <StatPill label="เจอแล้ว" value={challengeStatLabel(sightings)} />
            <StatPill label="ร่วมเล่น" value={participants ? challengeStatLabel(participants) : 'เริ่มเลย'} />
            <StatPill label="แท็ก" value={(challenge.hashtags || ['#TailLink'])[0]} wide />
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 18, flexWrap: 'wrap' }}>
            <button
              data-testid="v2-challenge-join-button"
              onClick={onJoin}
              style={{
                flex: '1 1 140px', height: 46, borderRadius: 999, border: 'none',
                background: '#fff', color: challenge.color || theme.primary,
                fontFamily: UI, fontSize: 14, fontWeight: 900, cursor: 'pointer',
                boxShadow: '0 10px 22px rgba(0,0,0,0.14)',
              }}
            >เข้าร่วมภารกิจ</button>
            <button
              data-testid="v2-challenge-open-button"
              onClick={() => navigate(`/v2/challenges/${challenge.slug}`)}
              style={{
                height: 46, padding: '0 16px', borderRadius: 999,
                border: '1px solid rgba(255,255,255,0.58)', background: 'rgba(255,255,255,0.16)',
                color: '#fff', fontFamily: UI, fontSize: 13, fontWeight: 900, cursor: 'pointer',
              }}
            >ดูบอร์ด</button>
            <button
              data-testid="v2-challenge-share-button"
              onClick={() => shareChallenge(challenge)}
              aria-label="แชร์ภารกิจ"
              title="แชร์ภารกิจ"
              style={{
                width: 46, height: 46, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.58)',
                background: 'rgba(255,255,255,0.16)', color: '#fff', cursor: 'pointer', fontSize: 17,
              }}
            >↗</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function StatPill({ label, value, wide }) {
  return (
    <div style={{
      minWidth: wide ? 118 : 78, padding: '8px 10px', borderRadius: 16,
      background: 'rgba(255,255,255,0.20)', border: '1px solid rgba(255,255,255,0.30)',
      backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
    }}>
      <div style={{ fontFamily: MONO, fontSize: 9, opacity: 0.75, fontWeight: 900 }}>{label}</div>
      <div style={{ fontFamily: UI, fontSize: 13, fontWeight: 900, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</div>
    </div>
  );
}